import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const CreateAdmissionInquiry = graphql.persisted(
  "CreateAdmissionInquiry",
  graphql(`mutation CreateAdmissionInquiry($input: CreateAdmissionInquiryInput!) {
    createAdmissionInquiry(input: $input) {
      admissionInquiry { id }
      userErrors { message path }
    }
  }`)
);

export { CreateAdmissionInquiry };
export function useCreateAdmissionInquiry() {
  return useMutation(CreateAdmissionInquiry);
}
